<template>
  <div class="match-block">
    <font-awesome-icon
      :icon="['fas','circle']"
      :title="title"/>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';

library.add(faCircle);

export default {
  props:{
    title: {
      type: String,
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "@/sass/custom.sass"

  .fa-circle
    color: $success
</style>
